export default __webpack_public_path__ + "static/media/poppins-all-400-normal.6fbfdac9.woff";